import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Laura G.',
  age: '37 años, mamá de 2',
  text: 'La semana pasada mi hijo empezó con tos y en vez de entrar en pánico fui directo a la guía. Me ayudó muchísimo a sentirme más tranquila.'
}, {
  name: 'Mariana R.',
  age: '42 años',
  text: 'Antes era automático: cualquier malestar y ya estaba pensando en medicamentos. Ahora aprendí a distinguir mucho mejor las situaciones.'
}, {
  name: 'Patricia S.',
  age: '49 años',
  text: 'La guía explica muy bien cuándo un remedio tiene sentido y cuándo consultar. Eso me pareció súper responsable.'
}, {
  name: 'Daniela M.',
  age: '34 años',
  text: 'No tenía idea de plantas medicinales, pero está tan bien explicado que fui aprendiendo de a poco.'
}, {
  name: 'Verónica T.',
  age: '45 años',
  text: 'Empecé por las recetas para dormir y en pocos días ya noté diferencia.'
}, {
  name: 'Andrea I.',
  age: '39 años',
  text: "No es solo 'tomá esto'. Explica por qué funciona y cómo prepararlo correctamente."
}, {
  name: 'Natalia P.',
  age: '41 años',
  text: 'Con mis hijos siempre me generaba culpa depender tanto de medicamentos. Esta guía me dio alternativas mucho más conscientes.'
}, {
  name: 'Claudia F.',
  age: '52 años',
  text: 'Las recetas están organizadas por sistema. Encontrás todo rapidísimo.'
}, {
  name: 'Sofía E.',
  age: '36 años',
  text: 'La tengo guardada en el celular y literalmente la uso todas las semanas.'
}, {
  name: 'Gabriela C.',
  age: '47 años',
  text: 'Antes dependía de tener una farmacia abierta. Ahora siento que tengo más herramientas.'
}, {
  name: 'Marcela D.',
  age: '55 años',
  text: 'Me recordó mucho a las cosas que hacía mi abuela. Sentí que recuperé conocimientos valiosos.'
}, {
  name: 'Julieta R.',
  age: '31 años',
  text: 'Me encantó porque todo está explicado simple, sin palabras difíciles.'
}, {
  name: 'Cecilia M.',
  age: '44 años',
  text: 'Los bonus son una locura. Solo por los extras ya vale muchísimo.'
}, {
  name: 'Teresa V.',
  age: '58 años',
  text: 'Lo compré pensando en dolores articulares y terminé usando muchísimas recetas más.'
}, {
  name: 'Romina S.',
  age: '33 años',
  text: 'Se nota que está armado con muchísimo detalle.'
}, {
  name: 'Elena G.',
  age: '61 años',
  text: 'Lo uso muchísimo para infusiones y remedios para dormir.'
}, {
  name: 'Carolina A.',
  age: '40 años',
  text: 'Me gustó porque no promete magia. Está explicado de forma responsable.'
},
// 5 New matching avatar testimonials
{
  name: 'Silvia B.',
  age: '48 años',
  text: 'Estaba cansada de tomar pastillas para el dolor de cabeza. Las infusiones que recomiendan acá me cambiaron las tardes.'
}, {
  name: 'Florencia L.',
  age: '35 años, mamá de 3',
  text: 'El botiquín infantil natural es oro puro. Ya no salgo corriendo a la farmacia por cualquier raspón o dolor de panza.'
}, {
  name: 'Mónica H.',
  age: '53 años',
  text: 'Pensé que los ingredientes iban a ser imposibles de conseguir, pero la mayoría ya los tenía en la cocina. ¡Súper práctico!'
}, {
  name: 'Valeria C.',
  age: '38 años',
  text: 'Lo leo desde la tablet mientras cocino. Las recetas en 10 minutos del bonus me salvaron las cenas de la semana.'
}, {
  name: 'Graciela M.',
  age: '59 años',
  text: 'Se lo recomendé a todas mis amigas. Volver a lo natural es lo mejor que podemos hacer por nuestro cuerpo a esta edad.'
}];
export function Testimonials() {
  return <section className="py-16 px-4 bg-black text-white" data-id="element-173">
      <div className="max-w-6xl mx-auto" data-id="element-174">
        <div className="text-center mb-12" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-heading font-black mb-4 uppercase text-brand-yellow" data-id="element-176">
            ⭐ RESEÑAS Y EXPERIENCIAS REALES
          </h2>
          <p className="text-xl font-medium" data-id="element-177">
            Miles de personas ya están usando esta guía 🌿
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-178">
          {testimonials.map((t, idx) => <div key={idx} className="bg-zinc-900 p-6 rounded-xl border border-zinc-800" data-id="element-179">
              <div className="flex gap-1 mb-3" data-id="element-180">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-yellow text-brand-yellow" data-id="element-181" />)}
              </div>
              <p className="text-gray-300 italic mb-4 font-medium leading-relaxed" data-id="element-182">
                "{t.text}"
              </p>
              <div data-id="element-183">
                <p className="font-bold text-white" data-id="element-184">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-185">{t.age}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}